import { ChangeEvent, ReactElement, useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import classnames from 'classnames/bind';
import { Info, Tooltip } from '@weareopenr/component-library';
import styles from './RadioButton.module.scss';

const cx = classnames.bind(styles);

interface IRadioButtonProps {
  name: string;
  value: string;
  label: string;
  toolTipText: string;
  logo: ReactElement;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isSelected?: boolean;
  error?: FieldError;
  hideRadio?: boolean;
}

const RadioButton = ({
  name,
  value,
  label,
  toolTipText,
  logo,
  onChange,
  isSelected = false,
  error,
  hideRadio,
}: IRadioButtonProps) => {
  const tooltipRef = useCallback((node: HTMLSpanElement | null) => {
    if (node) {
      const button = node.querySelector('button');
      if (button) {
        button.type = 'button';
      }
    }
  }, []);

  return (
    <label className={styles['label']} htmlFor={`${value}-option`}>
      <span className={cx('card', { 'card-selected': isSelected, 'card-error': !isSelected && !!error })}>
        <span className={styles['tooltip-wrapper']}>
          <span ref={tooltipRef}>
            <Tooltip text={toolTipText} position="top" hasArrow={true}>
              <Info />
            </Tooltip>
          </span>
        </span>
        <span className={styles['img-wrapper']}>{logo}</span>
        <span className={styles['input-wrapper']}>
          <span className={cx('text', { 'text-selected': isSelected })} data-testid={`p-${value}`}>
            {label}
          </span>
          <input
            type="radio"
            className={cx(hideRadio ? 'radio-hidden' : 'radio')}
            name={name}
            value={value}
            id={`${value}-option`}
            checked={isSelected}
            onChange={onChange}
            aria-label={value}
          />
        </span>
      </span>
    </label>
  );
};

export default RadioButton;
